import api from '../../api'

class User {
  constructor({ firstName, lastName, email, phone }) {
    this.firstName = firstName
    this.lastName = lastName
    this.email = email
    this.phone = phone
  }
}

const state = {
  user: undefined,
  error: false
}

const mutations = {
  setLoggedInUser: (state, user) => {
    state.user = new User(
      {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        phone: user.phone
      }
    )
  },
  setError: (state, error) => {
    state.error = error
  }
}

const actions = {
  async requestLoginCodeForEmail({ commit, rootState }, { email }) {
    rootState.loading = true
    await api.getLoginCode(email)
    commit('setError', null)
    rootState.loading = false
  },

  async postLoginCodeForEmail({ commit, rootState }, { email, loginCode }) {
    rootState.loading = true
    const response = await api.postLoginCode(email, loginCode)
    const { token, user } = response.data
    if (token) {
      // got a token.
      commit('setLoggedInUser', user)
    }
    rootState.loading = false
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
